import { sanitizeCustomHtml } from "@redotech/order-tracking-common/sanitize-custom-html";
import { TrackingPageTextBlock } from "@redotech/order-tracking-common/tracking-page-definition";
import { useRequiredContext } from "@redotech/react-util/context";
import { DEFAULT_EMAIL_LINK_COLOR } from "@redotech/redo-marketing-templates-common/email-builder";
import htmlReactParser from "html-react-parser";
import { memo, useMemo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import { TrackingPageContext } from "../context/tracking-page-context";
import {
  resolveTextBlockBodyFont,
  textBlockContentStyles,
} from "./shared/block-styles";

export const TextBlock = memo(function TextBlock(props: TrackingPageTextBlock) {
  const { pageSettings } = useRequiredContext(TrackingPageContext);

  const sanitizedHtml = useMemo(
    () => sanitizeCustomHtml(props.html),
    [props.html],
  );
  const hasContent = sanitizedHtml.trim().length > 0;
  const containerId = `text-block-${props._id}`;
  const linkColor =
    pageSettings?.typography.linkFontColor ?? DEFAULT_EMAIL_LINK_COLOR;

  return (
    <>
      <style>
        {textBlockContentStyles({
          containerId,
          pageSettings,
          linkColor,
          blockFontFamily: props.fontFamily,
        })}
      </style>
      <Flex
        dir="column"
        height="full"
        id={containerId}
        style={{
          backgroundColor:
            props.backgroundColor ??
            pageSettings?.blockSettings.backgroundColor,
          borderRadius: pageSettings?.blockSettings.borderRadius,
          fontFamily: resolveTextBlockBodyFont(pageSettings, props.fontFamily),
          color: pageSettings?.typography.bodyFontColor,
          fontSize: props.fontSize,
          lineHeight: props.lineHeight,
          padding: props.padding,
          overflow: "auto",
        }}
      >
        {hasContent ? (
          htmlReactParser(sanitizedHtml)
        ) : (
          <Text fontSize="sm" textColor="secondary">
            Text
          </Text>
        )}
      </Flex>
    </>
  );
});
